import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { MEDIA_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const MEDIA_METRIC = createPageSegmentLoadMetric({
	key: MEDIA_SEGMENT_KEY,
});
